// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2XOxr","controls":"styles_controls__23KXL","charLimit":"styles_charLimit__2WNJM","input":"styles_input__13gLX","send":"styles_send__2La6K"};